import { useState, memo, useMemo } from "react";
import { formatStat, getStringHash } from "../util/helpers";
import { Toaster } from "react-hot-toast";
import { Button } from "../components";

import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@mui/material";
import { IconBrandFacebook, IconBrandInstagram, IconBrandTiktok, IconBrandYoutube } from "@tabler/icons-react";
import ApplicantDrawer from "./ApplicantDrawer";

const platformToIcon = {
  "youtube": <IconBrandYoutube size="25" className="icon-colored" color="var(--main-text-color)"/>,
  "tiktok": <IconBrandTiktok size="25" className="icon-colored" color="var(--main-text-color)"/>,
  "facebook": <IconBrandFacebook size="25" className="icon-colored" color="var(--main-text-color)"/>,
  "instagram": <IconBrandInstagram size="25" className="icon-colored" color="var(--main-text-color)"/>
  }
function NewApplicantTable(props) {
  const { campaignId, creators: creatorsProp = [] } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedCreator, setSelectedCreator] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const headers = [ "Creator", "Followers", "Reach", "Industry", "Platform","Actions" ]

  const sortedCreators = useMemo(() => {
    return [...creatorsProp].sort(
      (a, b) =>
        (b.stats ? b.stats.totalFollowers : 0) -
        (a.stats ? a.stats.totalFollowers : 0),
    );
  }, [creatorsProp]);

  const rows = useMemo(() => {
    const search = props?.nameSearch?.toLowerCase() || "";
    return sortedCreators.filter(creator => creator.name?.toLowerCase().includes(search));
  }, [sortedCreators, props?.nameSearch]);

  return (
    <div style={{width: "100%" }}>
      <ApplicantDrawer campaignId={campaignId} open={open} onClose={() => setOpen(false)} creator={selectedCreator} setCreator={setSelectedCreator}/>
      <Stack direction="column" spacing={1} alignItems="center">
      <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    {headers.map((header) => (
                    <TableCell key={header}>
                        <Typography variant="bodysm" color="var(--body-text-color-600)">{header}</Typography>
                    </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {rows && rows.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map((creator) =>
                    <TableRow key={creator.userDocId || creator.id}>
                        <TableCell align="left" width="20%">
                            <Stack direction="row" spacing={2} alignItems="center" >
                                <img className="profile-image" loading="lazy" src={creator?.images?.length > 0 ? creator?.images[0] : `../gradient${getStringHash(creator?.name, 10)}.png`} alt={creator.name}/>
                                <Stack direction="column" spacing={0}>
                                    <Typography variant="bodyregm" color="var(--main-text-color)">{creator.name}</Typography>
                                </Stack>
                            </Stack>
                        </TableCell>
                        <TableCell align="left" width="12%">
                            <Typography variant="bodysm" color="var(--main-text-color)">{formatStat(creator?.stats?.totalFollowers)}</Typography>
                        </TableCell>
                        <TableCell align="left" width="12%">
                            <Typography variant="bodysm" color="var(--main-text-color)">{formatStat(creator?.stats?.totalReach)}</Typography>
                        </TableCell>
                        <TableCell align="left" width="25%">
                            <Typography variant="bodysm" color="var(--main-text-color)">{creator?.industries?.join(", ")}</Typography>
                        </TableCell>
                        <TableCell align="left" width="20%">
                        <Stack direction="row" spacing={1} alignItems="center" sx={{width: "100%"}}>
                            {creator?.stats?.channels?.map((channel) => <span key={channel.platform}>{platformToIcon[channel.platform]}</span>)}
                            </Stack>
                        </TableCell>

                        <TableCell align="left" width="12%">
                          <Stack direction="row" spacing={1} alignItems="center" sx={{width: "100%"}}>
                            <Button variant="outlined" className="outlined-button" color="info" onClick={() => {setOpen(true); setSelectedCreator(creator)}}>View More</Button>
                            </Stack>
                        </TableCell>
                    </TableRow> 
                )}
            </TableBody>
        </Table>
    </TableContainer>
    <TablePagination
      count={rows.length}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
    </Stack>
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
    </div>
  );
}

export default memo(NewApplicantTable); 